import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Pequeno delay para garantir que o componente foi renderizado completamente
    const timeoutId = setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'instant' // Mudamos para instant para evitar animação parcial
      });
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [pathname, search]);

  return null;
} 